import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import Orders from "../../images/order.png";
import CartOrders from "../../images/cartorders.png";
import IndividualOrders from "../../images/indivorders.png"

function Order() {
  const OrderDoc = {
    title: "Orders",
    description: "Learn how to manage and process orders efficiently.",
    sections: [
      {
        title: "Overview",
        content: "The orders panel displays customer orders.",
        image: Orders,
        imageAlt: "Order Dashboard Overview",
        imageCaption: "Figure 1: Comprehensive view of the Order Dashboard",
      },
  
      // Documentation for Cart Orders
      {
        title: "Cart Orders",
        content:
          "Cart orders are divided into two sections: Active Orders and Finished Orders. Each dropdown provides guidance on managing these processes.",
        image: CartOrders,
        imageAlt: "Cart Orders Overview",
        imageCaption: "Figure 2: View of the Cart Orders",
        subsections: [
          {
            title: "Active Orders",
            content: "Easily filter express orders from the main order list.",
            steps: [
              "Use the search button to find orders by order number (e.g., 1724842874791). Omit 'ORDERGH-' for optimal results.",
              "Once you find the desired order, click on ACTIONS (far right) to check recent order status, manage returns, and download invoices.",
              "ORDER DETAILS: Displays details of active orders with status options (e.g., pending, accepted, supplier notified).",
              "RESELLER INVOICE: Shows the invoice for the reseller, with an option to print.",
              "CUSTOMER INVOICE: Displays the customer's invoice, with an option to print.",
            ],
          },
          {
            title: "Finished Orders",
            content:
              "Finished orders show notifications and stages after an order is fulfilled.",
            steps: [
              "Use the search button to find orders by order number (e.g., 1724842874791). Omit 'ORDERGH-' for optimal results.",
              "Click ACTIONS (far right) to check recent order status, manage returns, and download invoices.",
              "ORDER DETAILS: Displays details of finished orders with status options.",
              "RESELLER INVOICE: Shows the invoice for the reseller, with an option to print.",
              "CUSTOMER INVOICE: Displays the customer's invoice, with an option to print.",
              "DELIVERY STICKER: Shows invoice date, due date, customer name, and contact number.",
            ],
          },
        ],
      },
  
      // Documentation for Individual Orders
      {
        title: "Individual Orders",
        content:
          "Individual orders display a list of single orders on the dashboard along with actions available for each.",
        image: IndividualOrders,
        imageAlt: "Individual Orders Overview",
        imageCaption: "Figure 3: Comprehensive view of Individual Orders",
  
        subsections: [
          {
            title: "Change Status",
            content: "Update order status and add notes.",
            steps: [
              "Search for each order by its ID (e.g., 20247-2811115-663).",
              "Change the order status (e.g., pending, accepted, etc.).",
              "ADD NOTES: Each order includes functionality to add notes.",
              "UPDATE ORDER: After changing the status or adding a note, click Update Order to submit changes.",
            ],
          },
          {
            title: "Edit Orders",
            content:
              "Express orders must be processed swiftly to meet delivery deadlines.",
            steps: [
              "EDIT CUSTOMER LOCATION: Click 'Add Location' to update the customer's latest location.",
              "EDIT ORDER NUMBER: Use the plus and minus signs to adjust the number of items ordered.",
              "CHANGE DELIVERY LOCATION: Modify the delivery location (note this may affect delivery costs).",
              "UPDATE ORDER: Click 'Update Order' to submit your changes.",
              "Generate a shipping label with the express shipping option.",
            ],
            note: "Remember: Express orders have a 2-hour processing time target from the moment they are received.",
          },
  
          {
            title: "More Operations",
            content: "Additional actions available for each order.",
            steps: [
              "VIEW CART",
              "EDIT SKU",
              "ADD NOTES",
              "DELIVERY MESSAGE",
              "PICKUP MESSAGE",
            ],
            note: "Remember: Express orders have a 2-hour processing time target from the moment they are received.",
          },
        ],
      },
    ],
  };
  

  return <FeatureDocumentation {...OrderDoc} />;
}

export default Order;
